import { useState } from "react";

export type SlugStatus = "idle" | "checking" | "available" | "taken";

export function useSlugValidation(
  checkSlugFn: (
    slug: string,
    excludeId?: string,
  ) => Promise<{ available: boolean }>,
  excludeId?: string,
): {
  status: SlugStatus;
  validate: (slug: string) => Promise<void>;
  reset: () => void;
} {
  const [status, setStatus] = useState<SlugStatus>("idle");

  const validate = async (slug: string) => {
    const trimmed = slug.trim();
    if (!trimmed) {
      setStatus("idle");
      return;
    }
    setStatus("checking");
    try {
      const result = await checkSlugFn(trimmed, excludeId);
      setStatus(result.available ? "available" : "taken");
    } catch {
      setStatus("idle");
    }
  };

  const reset = () => setStatus("idle");

  return { status, validate, reset };
}
